"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for release action request.
 *
 * @author Radek Beran
 */


var ReleaseActionRequestConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseActionRequestConverter, _DataObjectConverter_);

  function ReleaseActionRequestConverter() {
    _classCallCheck(this, ReleaseActionRequestConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionRequestConverter).apply(this, arguments));
  }

  return ReleaseActionRequestConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseActionRequestConverter = ReleaseActionRequestConverter;